import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

import { ScoreMeter } from './ScoreMeter'
import { queries } from '~/constants/mediaQuery'
import { LoadableCard } from '~/components/commons'

export const ScoreOverview = ({ data, loading }) => {
  const intl = useIntl()

  return (
    <ScoreOverviewDiv loading={loading} disableMediaQuery={true}>
      <div className="performance-average">
        <div className="performance-graphics">
          <ScoreMeter score={data?.average || 0} />
          <div className="performance-average-score">
            <div>{data?.average || 0}</div>
            <div>/100</div>
          </div>
        </div>
        <div className="performance-text">
          <div className="performance-title">
            {intl.formatMessage({ id: 'Performance of your profile' })}
          </div>
          <div className="performance-description">
            {intl.formatMessage({
              id:
                'Complete your locations info and keep improving your score to have better results.',
            })}
          </div>
        </div>
      </div>
      <div className="performance-cards">
        <div>
          <div className="card-top-color" data-color="red"></div>
          <div className="performance-card">
            <div>{data?.lowperformance || 0}</div>
            <div>{intl.formatMessage({ id: 'locations with' })}</div>
            <div>{intl.formatMessage({ id: 'low performance' })}</div>
          </div>
        </div>
        <div>
          <div className="card-top-color" data-color="yellow"></div>
          <div className="performance-card">
            <div>{data?.mediumperformance || 0}</div>
            <div>{intl.formatMessage({ id: 'locations with' })}</div>
            <div>{intl.formatMessage({ id: 'medium performance' })}</div>
          </div>
        </div>
        <div>
          <div className="card-top-color" data-color="green"></div>
          <div className="performance-card">
            <div>{data?.highperformance || 0}</div>
            <div>{intl.formatMessage({ id: 'locations with' })}</div>
            <div>{intl.formatMessage({ id: 'high performance' })}</div>
          </div>
        </div>
      </div>
    </ScoreOverviewDiv>
  )
}

const ScoreOverviewDiv = styled(LoadableCard)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e2e8f0;
  padding: 2em;
  gap: 2em;
  border-radius: 0.5em;
  box-shadow: none !important;

  @media ${queries.less.lg} {
    flex-direction: column;
    gap: 3em;
  }

  .performance-average {
    width: 50%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 2em;
    text-wrap: wrap;

    @media ${queries.less.lg} {
      width: 100%;
    }

    @media ${queries.less.sm} {
      flex-direction: column;
    }

    .performance-graphics {
      height: min-content;
      position: relative;

      &:hover {
        .performance-average-score {
          div:nth-child(1) {
            font-size: 2.7em;
          }
        }
      }
    }

    .performance-average-score {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 0;

      div:nth-child(1) {
        color: #1a202c;
        font-size: 2.5em;
        font-weight: 700;
        transition: font-size 0.2s ease-out;
      }

      div:nth-child(2) {
        color: #718096;
        font-size: 1.2em;
        font-weight: 400;
      }
    }

    .performance-text {
      display: flex;
      flex-direction: column;
      max-width: 300px;

      @media ${queries.less.sm} {
        max-width: 100%;
        align-items: center;
        text-align: center;
      }

      .performance-title {
        color: #1a202c;
        font-size: 1.3em;
        font-weight: 700;
      }

      .performance-description {
        color: #4a5568;
        font-size: 1em;
      }
    }
  }

  .performance-cards {
    width: 50%;
    display: flex;
    gap: 1em;

    @media ${queries.less.lg} {
      width: 100%;
    }

    @media ${queries.less.sm} {
      flex-direction: column;
    }

    > div {
      display: flex;
      flex-direction: column;
      border: 1px solid #e2e8f0;
      border-radius: 0.5em;
      width: 33%;

      @media ${queries.less.sm} {
        width: 100%;
      }
    }

    .performance-card {
      padding: 1em;

      div:nth-child(1) {
        color: #4a5568;
        font-weight: 700;
        font-size: 1.7em;
      }

      div:nth-child(2) {
        color: #4a5568;
        font-weight: 400;
        font-size: 0.9em;
      }

      div:nth-child(3) {
        color: #1a202c;
        font-weight: 500;
        font-size: 1em;
        margin-top: -5px;
      }
    }

    .card-top-color {
      width: 100%;
      height: 0.5em;
      border-radius: 0.5em 0.5em 0 0;
    }

    .card-top-color[data-color='red'] {
      background-color: #f56565;
    }

    .card-top-color[data-color='yellow'] {
      background-color: #ecc94b;
    }

    .card-top-color[data-color='green'] {
      background-color: #48bb78;
    }
  }
`
